namespace RedBullMOBILE360.AutomaticReports {
    export interface MonitorAlertForm {
        QueryString: Serenity.StringEditor;
        AlertChannel: Serenity.StringEditor;
        Audience: Serenity.StringEditor;
        Enabled: Serenity.IntegerEditor;
        AlertMsg: Serenity.StringEditor;
        Schedule: Serenity.StringEditor;
    }

    export class MonitorAlertForm extends Serenity.PrefixedContext {
        static formKey = 'AutomaticReports.MonitorAlert';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MonitorAlertForm.init)  {
                MonitorAlertForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;

                Q.initFormType(MonitorAlertForm, [
                    'QueryString', w0,
                    'AlertChannel', w0,
                    'Audience', w0,
                    'Enabled', w1,
                    'AlertMsg', w0,
                    'Schedule', w0
                ]);
            }
        }
    }
}
